<script>

import DrawerComponent from "@/components/Drawer.vue";
import FormProfil from "@/components/profil/update/FormProfil.vue";

export default {
  name: 'DrawerUpdateProfil',
  components: {FormProfil, DrawerComponent},
  props: {
    profil: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <drawer-component title="Mes informations">
    <form-profil :profil="profil" @close-view="$emit('closeView')" />
  </drawer-component>
</template>